<template>
  <div>
    <Header :isHome="false"></Header>
    <div class="top-bg" style="padding-top: 7rem"></div>
    <div class="container">
      <div
        style="
          font-size: 1rem;
          font-weight: 500;
          color: #999;
          margin-bottom: 1rem;
        "
      >
        <span
          class="hover-light"
          style="cursor: pointer; margin-right: 0.5rem"
          @click="$router.push({ name: 'home' })"
          >Home</span
        >>
        <span
          class="hover-light"
          style="margin-left: 0.5rem; margin-right: 0.5rem; cursor: pointer"
          @click="$router.push({ name: 'productList' })"
          >All products</span
        >>
        <span style="margin-left: 0.5rem; color: #000">Products Details</span>
      </div>
      <div
        style="border-bottom: 1px solid #e8e8e8; padding-bottom: 20px"
        class="df row"
      >
        <div class="left" :class="`${isMobile ? 'col-12' : 'col-5'}`">
          <div id="wrap">
            <div class="pic" :style="{ backgroundImage: `url(${currentImg})` }">
              <i
                @click="collect"
                class="poa"
                :class="data.collected ? 'el-icon-star-on' : 'el-icon-star-off'"
                style="
                  right: 1rem;
                  top: 1rem;
                  font-size: 1.5rem;
                  cursor: pointer;
                "
              ></i>
            </div>
            <div class="tab df jcsb">
              <div class="img-wrap" ref="imgWrap">
                <div
                  class="img"
                  :style="{ backgroundImage: `url(${item})` }"
                  @click="
                    (activeIndex = index),
                      (currentImg = data.main_pics[activeIndex])
                  "
                  :class="{ on: activeIndex == index }"
                  v-for="(item, index) in data.main_pics"
                ></div>
                <!-- <div class="img"
									:style="{backgroundImage: `url(https://pic.oointer.com/upload/20231123/4/2_4_20231123175439.jpeg)`}"
									@click="activeIndex=index,currentImg=data.main_pics[activeIndex]"
									:class="{on:activeIndex==index}" v-for="(item,index) in 8">
								</div> -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="right wow fadeInUp animated"
          :class="`${isMobile ? 'col-12' : 'col-7'}`"
          style="flex: 1"
        >
          <div class="title">{{ data.title }}</div>
          <div
            class="describe"
            ref="describe"
            :class="{ text_over_2line: hideDetail }"
          >
            {{ data.sub_title }}
          </div>
          <div
            v-if="hideDetail"
            style="text-decoration: underline; color: #22f7d3; cursor: pointer"
            @click="hideDetail = false"
            class="df"
          >
            more>
          </div>
          <div class="title df aic" style="margin-top: 3rem">
            Product information
          </div>
          <div
            class="attr row wow fadeInUp animated"
            style="padding-bottom: 1rem"
          >
            <div
              class="df"
              :class="`${isMobile ? 'col-12' : 'col-6'}`"
              style="margin-top: 0.5rem"
              v-if="data.category"
            >
              <div class="key" style="font-weight: bold; margin-right: 0.6rem">
                Type:
              </div>
              <div class="value" style="margin-right: 1rem">
                {{ data.category }}
              </div>
            </div>
            <div
              class="df"
              :class="`${isMobile ? 'col-12' : 'col-6'}`"
              style="margin-top: 0.5rem"
              v-if="data.brand"
            >
              <div class="key" style="font-weight: bold; margin-right: 0.6rem">
                Brand:
              </div>
              <div class="value" style="margin-right: 1rem">
                {{ data.brand.name }}
              </div>
            </div>
            <div
              class="df"
              :class="`${isMobile ? 'col-12' : 'col-6'}`"
              style="margin-top: 0.5rem"
              v-if="data.country"
            >
              <div class="key" style="font-weight: bold; margin-right: 0.6rem">
                Origin:
              </div>
              <div class="value" style="margin-right: 1rem">
                {{ data.country.englishName }}
              </div>
            </div>
            <div
              class="df"
              :class="`${isMobile ? 'col-12' : 'col-6'}`"
              style="margin-top: 0.5rem"
              v-if="data.authentications"
            >
              <div class="key" style="font-weight: bold; margin-right: 0.6rem">
                authentications:
              </div>
              <div
                class="value"
                style="margin-right: 1rem"
                v-for="(item2, index2) in data.authentications"
              >
                {{ item2.name }}
              </div>
            </div>
            <div
              class="df"
              v-for="(item, index) in data.properties"
              :class="`${isMobile ? 'col-12' : 'col-6'}`"
              style="margin-top: 0.5rem"
              :key="index"
              v-if="data.properties"
            >
              <div class="key" style="font-weight: bold">{{ item.label }}:</div>
              <div class="value" style="margin-right: 1rem">
                {{ item.value }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="merchant wow fadeInUp animated">
        <div class="title mb-2">Service provider</div>
        <div class="df aic jcsb row" v-if="data.provider">
          <div
            class="df aic"
            :class="{ fdc: isMobile, 'col-12': isMobile, 'col-9': !isMobile }"
          >
            <img :src="data.provider.logo" width="147" height="147" alt="" />
            <div class="df fdc" style="margin-left: 1rem">
              <div class="title" style="font-size: 1.3rem">
                {{ data.provider ? data.provider.providerName : "" }}
              </div>
              <div class="df fww" style="margin: 0.5rem 0">
                <div
                  class="tag df aic jcc"
                  v-for="(item, index) in data.provider.certifications"
                  :key="index"
                >
                  {{ item.name }}
                </div>
              </div>
              <div style="color: #6a6a6a" class="providerDescription">
                {{ data.provider.providerDescription }}
              </div>
            </div>
          </div>
          <div
            class="df aic"
            :class="{ fdc: !isMobile, 'col-12': isMobile, 'col-2': !isMobile }"
            style="margin-top: 1rem"
          >
            <div
              style="background: #22f7d3"
              @click="route('Inquire')"
              class="button aic df jcc"
            >
              Inquire now
            </div>
            <div
              :style="`${
                isMobile ? 'margin-left: 1rem;' : 'margin-top: 1rem;'
              }`"
              @click="route('homepage')"
              style="background: transparent; border: 1px solid #000"
              class="button aic df jcc"
            >
              Go homepage
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        title="Inquiry content"
        :visible.sync="visible2"
        :width="`${isMobile ? '75' : '35'}%`"
        center
      >
        <el-input
          style="margin-bottom: 1rem"
          v-model="params2.name"
          placeholder="*Enter Name"
        />
        <el-input
          style="margin-bottom: 1rem"
          v-model="params2.contact"
          placeholder="*Enter Email"
        />
        <el-input
          type="textarea"
          :rows="4"
          v-model="params2.content"
          placeholder="*Enter content"
        />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="contact"
            style="background-color: #22f7d3; width: 100%; color: #000"
            >Send</el-button
          >
        </span>
      </el-dialog>
      <div
        style="border-top: 1px solid #e8e8e8; width: 100%"
        v-html="data.description"
      ></div>
      <div
        style="border-top: 1px solid #000; margin-top: 1rem; padding: 1rem 0"
      >
        <div class="df jcsb">
          <div class="title" style="white-space: nowrap">Similar products</div>
          <div
            class="title hover-light"
            style="text-align: right; cursor: pointer"
            @click="
              $router.push({
                name: 'productList',
                query: { categoryId: data.category_ids[0] },
              })
            "
          >
            more
          </div>
        </div>
        <div class="main-box df jcsa fww" v-if="isMobile">
          <template v-for="(item, index1) in list">
            <productItem
              style="width: 48%"
              :col="null"
              :item="item"
              :key="index1"
            >
            </productItem>
            <productItem
              style="width: 48%; opacity: 0"
              :col="null"
              :item="item"
              v-if="index1 == data.length - 1 && data.length % 2 == 1"
            >
            </productItem>
          </template>
        </div>
        <div class="main-box row" v-else>
          <productItem
            :col="isMobile ? 'col-6' : 'col-3'"
            :item="item"
            v-for="(item, index1) in list"
            :key="index1"
          >
          </productItem>
        </div>
      </div>
    </div>
    <Footer style="margin-top: 3rem"></Footer>
  </div>
</template>

<script>
import Header from "/src/components/header.vue";
import Footer from "/src/components/footer.vue";
import productItem from "@/components/product/productItem.vue";
export default {
  components: {
    Header,
    Footer,
    productItem,
  },
  data() {
    return {
      isMobile: false,
      visible2: false,
      currentImg: "",
      hideDetail: false,
      activeIndex: 0,
      data: {},
      list: [],
      params2: {
        productCustomId: null,
        content: "",
        providerId: null,
        contact: "",
        name: "",
      },
      //   isuserlevel: false,
      //   默认全部都是会员
      isuserlevel: true,
    };
  },
  mounted() {
    this.isMobile = localStorage.getItem("isMobile") == "null" ? false : true;
    this.getData(this.$route.query.id);
    this.params2.pid = this.$route.query.id;
  },
  methods: {
    route(name) {
      if (!this.isuserlevel) {
        this.$bus.$emit("userleveldialog", true);
      } else {
        if (name == "Inquire") {
          this.visible2 = true;
        } else {
          this.$router.push({
            name: "supplierdetail",
            query: {
              id: this.data.providerId,
            },
          });
        }
      }
    },
    async collect() {
      let res = await this.$post(`/gci/product/${this.data.id}/collection`);
      this.$bus.$emit("message", {
        type: 2,
        msg: res.msg,
      });
      this.getData(this.data.id);
    },
    formatRichText(html) {
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      newContent = newContent.replace(/<br[^>]*\/>/gi, "");
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"'
      );
      return newContent;
    },
    async getData(id) {
      let { data } = await this.$get(`/gci/product/${id}/detail`);
      this.data = data;
      if (data.main_pics) this.currentImg = data.main_pics[0];
      this.params2.providerId = data.providerId;
      this.$nextTick(() => {
        if (this.$refs.describe.offsetHeight > 64) this.hideDetail = true;
      });
      this.data.description = this.formatRichText(this.data.description);
      this.getList(data.category_ids[0]);
    },
    teanslate(num) {
      console.log(this.$refs.imgWrap.scrollLeft);
      this.$refs.imgWrap.scrollLeft += num;
    },
    async getList(categoryId) {
      let { data } = await this.$get("/gci/products", {
        categoryId,
        page: 1,
        status: 2,
        perPage: 8,
        state: "true",
      });
      this.list = data.items;
    },
    async contact() {
      let res = await this.$post("/gci/product/enquiry/add", this.params2);
      this.visible2 = false;
      this.$bus.$emit("message", {
        type: 2,
        msg: res.msg,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.providerDescription {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.main-box {
  margin-top: 2rem;
}

div {
  box-sizing: border-box;
}

#wrap {
  width: 100%;
  height: 500px;
}

.pic {
  width: 100%;
  height: 400px;
  // border: 1px solid #ccc;
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.pic-cover {
  position: absolute;
  top: 0;
  left: 0;
}

.cover {
  width: 200px;
  height: 200px;
  background-image: url(../../assets/imgs/cover.png);
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  cursor: move;
}

.img-wrap {
  width: 1000px;
  white-space: nowrap;
}

.tab {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  margin-top: 20px;
}

::-webkit-scrollbar {
  /*滚动条基本样式，高度*/
  height: 6px;
  width: 10px;
  cursor: pointer;
}

::-webkit-scrollbar-thumb {
  /*滚动条上层颜色*/
  border-radius: 5px;
  cursor: pointer;
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ccc;
}

::-webkit-scrollbar-track {
  /*滚动条底层颜色*/
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  // background: rgba(0, 0, 0, 0.1);
}

.img {
  display: inline-block;
  // margin-bottom: 10px;
  width: 50px;
  height: 50px;
  margin-right: 13px;
  cursor: pointer;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  &:hover {
    border: 2px solid #24e9e5;
  }
}

.on {
  border: 2px solid #24e9e5;
}

.opetate {
  height: 50px;
  width: 25px;
  background: #f2f2f2;
  border-radius: 2px;
  cursor: pointer;
  z-index: 2;
}

.show {
  width: 400px;
  height: 400px;
  position: absolute;
  top: 0;
  right: -410px;
  display: none;
  // background: url(images/1.jpg) no-repeat;
}

.title {
  // white-space: nowrap;
  color: #000;
  font-size: 1.5rem;
  font-weight: bold;
  // margin-top: 0.5rem;
  width: 100%;
  position: relative;

  // &:before {
  // 	content: "";
  // 	display: inline-block;
  // 	width: 0.5rem;
  // 	height: 1.5rem;
  // 	border-radius: 0.2rem;
  // 	margin-right: 0.3rem;
  // 	background-color: #24e9e5;
  // 	position: absolute;
  // 	left: -0.8rem;
  // 	top: 0.5rem;
  // }
}

.describe {
  font-size: 1rem;
  color: #777777;
  line-height: 2.01rem;
  margin-top: 1rem;
  max-height: 170px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 10px;
    cursor: pointer;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc; // 滑块颜色
    border-radius: 5px; // 滑块圆角
  }
}

.attr {
  margin-top: 1rem;
}

.merchant {
  padding-bottom: 2rem 0;
  margin: 2rem 0;
}

.tag {
  color: #000;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  padding: 2px 5px;
  height: 1.5rem;
  border-radius: 20px;
}

.button {
  width: 10rem;
  height: 3rem;
  opacity: 1;
  color: #000;
  border: none;
  flex-wrap: nowrap;
  padding: 0;
  font-weight: bold;

  &:hover {
    box-shadow: 0 0 14px #ccc;
  }
}
</style>
